import ReactOnRails from 'react-on-rails/client';
import Toast from '../../ror_components/Toast.tsx';

ReactOnRails.register({Toast});